import React, { useState } from 'react';
import PropTypes from 'prop-types';

import * as utils from '../../../utils';
import { Button } from '@upmc/ims.component-library';
import {
	TextboxTypes,
	// UpmcEsoSearch ,
	Textbox,
} from '../../../components/UI/Input';
import { Headline6 } from '../../../components/UI/MDC/Typography/Typography';
import Card from '../../../components/UI/MDC/Card/Card';
import List, {
	ListItem,
	MDCListItemGraphic,
} from '../../../components/UI/MDC/List/List';
import Icon from '../../../components/UI/MDC/Icon/Icon';
import classes from '../UserAccessReview.module.scss';

const UpmcEsoSearch = props => {
	const {
		formDetails,
		searchResults,
	} = props;

	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [middleInitial, setMiddleInitial] = useState('');
	const [ntid, setNtid] = useState('');

	const generateSearchInput = (title, key, value, handler) => {
		return (
			<div
				className={utils.concatenateClassNames('full--width', classes)}
			>
				<div
					className={utils.concatenateClassNames(
						['edit-input__group'],
						classes
					)}
				>
					<div
						className={utils.concatenateClassNames(
							['edit-input__group--label'],
							classes
						)}
					>
						<label
							htmlFor={key}
							className={utils.concatenateClassNames(
								['edit-input__label--textbox'],
								classes
							)}
						>
							<Headline6
								className={utils.concatenateClassNames(
									['edit-input__label--small'],
									classes
								)}
							>
								{title}
							</Headline6>
						</label>
					</div>
					<Textbox
						id={key}
						type={TextboxTypes.TEXT}
						name={key}
						onChange={e => handler(e.target.value)}
						className={utils.concatenateClassNames(
							['edit-input__textbox', 'eso-search__text-input'],
							classes
						)}
						value={value}
						disabled={false}
					/>
				</div>
			</div>
		);
	};

	const resetForm = () => {
		setFirstName('');
		setLastName('');
		setMiddleInitial('');
		setNtid('');
	};

	const setSearchResultsBanner = () => {
		let searchResultsBanner = null;
		if (searchResults) {
			if (searchResults.results && searchResults.results.length >= 100) {
				searchResultsBanner = (
					<div>
						Notice: More than 100 results were returned and the list
						below has been truncated. Please continue to refine your
						search criteria.
					</div>
				);
			} else if (
				searchResults.results &&
				searchResults.results.length === 0
			) {
				searchResultsBanner = (
					<div>
						Notice: No results were returned. Please continue to
						refine your search criteria.
					</div>
				);
			}
		}
		return searchResultsBanner;
	};

	const searchForm = (
		<Card xlarge>
			{/* First Name */}
			{generateSearchInput(
				'First Name',
				'firstName',
				firstName,
				setFirstName
			)}

			{/* Last Name */}
			{generateSearchInput(
				'Last Name',
				'lastName',
				lastName,
				setLastName
			)}
			{/* Middle Initial */}
			{generateSearchInput(
				'Middle Initial',
				'middleInitial',
				middleInitial,
				setMiddleInitial
			)}

			{/* NTID */}
			{generateSearchInput('NTID', 'ntid', ntid, setNtid)}

			{/* Search Button */}
			<div
				className={utils.concatenateClassNames('full--width', classes)}
			>
				<Button
					sx={{ m: '5px' }}
					onClick={() => {
						resetForm();
						props.onClear();
					}}
					variant='outlined'
				>
					Clear
				</Button>
				<Button
					sx={{ m: '5px' }}
					onClick={() =>
						props.onSearch({
							firstName: firstName,
							lastName: lastName,
							middleInitial: middleInitial,
							ntid: ntid,
						})
					}
				>
					Search
				</Button>
			</div>
		</Card>
	);

	const searchList = (
		<div className={classes['eso-search__list--results']}>
			{setSearchResultsBanner()}
			<List
				twoLine
				dense
				xlarge
				handleSelect={activatedItemIndex => {
					props.onChange(
						{
							target: {
								value: searchResults.results[
									activatedItemIndex
								],
							},
						},
						props.id
					);
				}}
			>
				{searchResults.results
					? searchResults.results.map(result => {
							return (
								<ListItem
									key={result.esoId}
									className={classes['full--height']}
								>
									<MDCListItemGraphic
										graphic={<Icon icon='account_circle' />}
									/>
									<div className='mdc-list-item__text'>
										<div className='mdc-list-item__primary-text'>
											<u>{`${result.lastName}, ${
												result.firstName
											} ${
												result.middleInitial
													? result.middleInitial.toLowerCase() ===
													  'nomi'
														? ''
														: result.middleInitial
													: ''
											}`}</u>
											<span
												className={
													classes[
														'mdc-list-item__secondary-text--padding'
													]
												}
											>
												{result.isManager
													? ' (manager)'
													: ''}
											</span>
										</div>
										<div className='mdc-list-item__secondary-text'>
											<span
												className={
													classes[
														'mdc-list-item__secondary-text--padding'
													]
												}
											>
												<b>Network ID</b>:{' '}
												{result.ntid
													? result.ntid
													: 'N/A'}
											</span>
											<span
												className={
													classes[
														'mdc-list-item__secondary-text--padding'
													]
												}
											>
												<b>Job Title</b>:{' '}
												{result.jobTitle
													? result.jobTitle
													: 'N/A'}
											</span>
											<span
												className={
													classes[
														'mdc-list-item__secondary-text--padding'
													]
												}
											>
												<b>Department</b>:{' '}
												{result.department
													? result.department
													: 'N/A'}{' '}
											</span>
										</div>
									</div>
								</ListItem>
							);
					  })
					: null}
			</List>
		</div>
	);

	return formDetails ? (
		<React.Fragment>
			<section className={classes['user-search__container--vert']}>
				{searchForm}
				{searchList}
			</section>
		</React.Fragment>
	) : null;
};

export default UpmcEsoSearch;

/*
TODO:
- only pass the form object rather than the entire form state
- add prop type (custom) for the object shape
    {
        label:
        value:
        validation: {}
    }
*/

export const upmcEsoSearchPropTypes = {
	entryKey: PropTypes.string,
	formDetails: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.object,
		validation: PropTypes.shape({
			required: PropTypes.bool,
			valid: PropTypes.bool,
		}),
	}),
	handleChange: PropTypes.func,
	inputType: PropTypes.string,
	searchResults: PropTypes.arrayOf(
		PropTypes.shape({
			count: PropTypes.number,
			results: PropTypes.shape({
				department: PropTypes.string,
				email: PropTypes.string,
				EmployeeStatus: PropTypes.bool,
				esoFiId: PropTypes.number,
				esoId: PropTypes.string,
				hospitalAffiliation: PropTypes.string,
				familiarEso: PropTypes.string,
				firstName: PropTypes.string,
				isManager: PropTypes.string,
				isPrimary: PropTypes.bool,
				isRetired: PropTypes.bool,
				isServiceAccount: PropTypes.bool,
				jobTitle: PropTypes.string,
				lastName: PropTypes.string,
				Manager: PropTypes.string,
				middleInitial: PropTypes.string,
				ntid: PropTypes.string,
			}),
		})
	),
};

UpmcEsoSearch.propTypes = upmcEsoSearchPropTypes;
